<template>
  <v-container class="page">
    <Headline
      :title="headlineText"
      icon="mdi-account-group"
    />
    <router-view
      @setPageMode="setPageMode"
      @cancel="headlineText = $t('accAdmin.userList.headline')"
    ></router-view>
  </v-container>
</template>

<script lang="js">
import Headline from '@/common/Headline.vue';

export default {
  name: 'Groups',
  components: {
    Headline
  },
  data () {
    return {
      pageMode: 'table', // values: table, edit, create
      headlineText: this.$t('accAdmin.group.headline')
    };
  },
  methods: {
    setPageMode (mode, headlineParam = '') {
      this.pageMode = mode;
      switch (mode) {
        case 'create':
          this.headlineText = this.$t('accAdmin.group.create');
          break;
        case 'edit':
          this.headlineText = headlineParam;
          break;
        default: // 'table':
          this.headlineText = this.$t('accAdmin.group.headline');
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>
